import type { CreateJobInput } from '@chukua/common';
import type { JobType } from '../../reference-data/reference-data.api';
import { JobIntakeForm } from '../features/intake/components/JobIntakeForm';
import { JobIntakeMissingItems } from '../features/intake/components/JobIntakeMissingItems';
import type { JobDetail } from '../jobs.api';

interface JobDetailsTabProps {
  job: JobDetail;
  jobTypes: JobType[];
  error: string | null;
  saving: boolean;
  onSave: (input: CreateJobInput) => Promise<void>;
}

/** What quick-create started (`JobIntakeForm`) plus what's still missing — a job's own Details tab once it has a record page. */
export function JobDetailsTab({ job, jobTypes, error, saving, onSave }: JobDetailsTabProps) {
  return (
    <>
      <JobIntakeMissingItems job={job} jobTypes={jobTypes} />
      <JobIntakeForm job={job} jobTypes={jobTypes} error={error} saving={saving} onSave={onSave} />
    </>
  );
}
